import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useState, forwardRef } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import styles from "../styles/StepFour.module.css";
// import { flavourOptions } from '../data';
import Select from "react-select";

const StepFour = ({ setStep, formValues, setFormValues, origin, distance }) => {
    console.log("formvalues in step four", formValues);
    console.log("checking for airport", origin.types);
    // const [calendarClose, setCalendarClose] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedOption, setSelectedOption] = useState({
        value: "NameBoard",
        label: "Nameboard",
    });
    const [selectedOptionSecond, setSelectedOptionSecond] = useState({
        value: "Immediately",
        label: "Immediately",
    });

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormValues({ ...formValues, [name]: value });
        if (errors.hasOwnProperty([name])) {
            delete errors[[name]];
        }
    };
    console.log("company logo", formValues.NameBoard);

    // const handleDropdownChange = (event) => {
    //     setSelectedOption(event.target.value);
    // };

    const options = [
        { value: "NameBoard", label: "Nameboard" },
        { value: "CompanyLogo", label: "Company Logo" },
        // { value: 'AnonymousName', label: 'Anonymous' },
    ];

    const optionsSecond = [
        { value: "Immediately", label: "Immediately" },
        { value: "15minutes", label: "15 minutes" },
        { value: "30minutes", label: "30 minutes" },
        { value: "45minutes", label: "45 minutes" },
        { value: "1hour", label: "1 hour" },
    ];

    // const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    //     <button
    //         className={`${styles.dateTimeBtn}`}
    //         // onClick={() => setShowDatePicker(!showDatePicker)}
    //         onClick={onClick}
    //         ref={ref}
    //     >
    //         {formValues.DateTime && calendarClose
    //             ? "Change Date & Time"
    //             : "Choose Date & Time"}
    //     </button>
    // ));

    // const handleSelect = () => {
    //     console.log("Date is Selected: ", formValues.DateTime);
    // };

    const validateForm = () => {
        let errors = {};

        if (!formValues.FirstName.trim()) {
            errors.FirstName = "First name is required";
        }
        if (!formValues.LastName.trim()) {
            errors.LastName = "Last name is required";
        }
        if (!formValues.Email.trim()) {
            errors.Email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formValues.Email)) {
            errors.Email = "Email is invalid";
        }
        if (!formValues.Phone.trim()) {
            errors.Phone = "Phone number is required";
        } else if (!/^\d+$/.test(formValues.Phone)) {
            errors.Phone = "Phone number is invalid";
        }
        // if (!formValues.DateTime) {
        //     errors.DateTime = "Date and time are required";
        // }
        // if (formValues.Passengers < 0) {
        //     errors.Passengers = "Number of passengers is invalid";
        // }
        // if (formValues.Suitcases < 0) {
        //     errors.Suitcases = "Number of Suitcases is invalid";
        // }
        // if (formValues.HandCarry < 0) {
        //     setFormValues({ ...formValues, HandCarry: 0 })
        // }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    return (
        <div className="container pb-5">
            <nav className="container text-center">
                <img
                    className="img-fluid pt-4"
                    src="images/logo.svg"
                    alt="pegasus chauffeur"
                />
                <p className={`my-5 py-3 text-white ${styles.heading}`}>
                    Use the form below to check the pricing for our all
                    available vehicles. Smart, Secure, Online Payment System
                    designed for our valuable customers.
                </p>
            </nav>

            <img
                src="images/navigation-bar-step4.svg"
                alt="first step"
                className="img-fluid mb-5"
            />
            <div className={`${styles.box}`}>
                <h3 className={`${styles.boxHeading}`}>Add Contact Details</h3>
                {/* <p>{errors}</p> */}
                <div className="row mb-5">
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            First Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter First Name"
                            name="FirstName"
                            onChange={handleFormChange}
                            value={formValues.FirstName}
                        />
                        {errors.FirstName && (
                            <span className={styles.starick}>
                                {errors.FirstName}
                            </span>
                        )}
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Last Name {""}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Last Name"
                            name="LastName"
                            onChange={handleFormChange}
                            value={formValues.LastName}
                        />
                        {errors.LastName && (
                            <span style={{ color: "red" }}>
                                {errors.LastName}
                            </span>
                        )}
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Email Address {""}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Email Address"
                            name="Email"
                            onChange={handleFormChange}
                            value={formValues.Email}
                        />
                        {errors.Email && (
                            <span style={{ color: "red" }}>{errors.Email}</span>
                        )}
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Phone Number {""}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <PhoneInput
                            country={"gb"}
                            inputStyle={{
                                width: "100%",
                                border: "1px solid #212121",
                            }}
                            buttonStyle={{
                                border: "1px solid #212121",
                            }}
                            value={formValues.Phone}
                            onChange={(e) =>
                                setFormValues({
                                    ...formValues,
                                    Phone: e,
                                })
                            }
                        />
                        {errors.Phone && (
                            <span style={{ color: "red" }}>{errors.Phone}</span>
                        )}
                    </div>
                </div>
                {/* calender */}
                {/* <h3 className={`${styles.boxHeading}`}>Add Booking Details</h3>
                {formValues.DateTime && calendarClose ? (
                    <div>
                        <label className={styles.formLabel}>Date & Time</label>
                        <div className="d-flex justify-content-evenly align-items-center">
                            <input
                                disabled
                                value={formValues.DateTime}
                                className={styles.dateTimeInput}
                            />
                            <DatePicker
                                selected={formValues.DateTime}
                                onChange={(date) =>
                                    setFormValues({
                                        ...formValues,
                                        DateTime: date,
                                    })
                                }
                                minDate={new Date()}
                                locale="en"
                                showTimeSelect
                                timeFormat="p"
                                timeIntervals={15}
                                dateFormat="Pp"
                                closeOnScroll={(e) => e.target === document}
                                customInput={<ExampleCustomInput />}
                                wrapperClassName={styles.datePicker}
                                onSelect={handleSelect}
                                required
                            />
                        </div>
                        <br />
                        {errors.DateTime && (
                            <span style={{ color: "red" }}>
                                {errors.DateTime}
                            </span>
                        )}
                        <br />
                    </div>
                ) : (
                    <div className="text-center">
                        <div
                            className={`d-flex justify-content-center align-items-center mb-5 ${styles.datePicker}`}
                        >
                            <DatePicker
                                selected={formValues.DateTime}
                                onChange={(date) =>
                                    setFormValues({
                                        ...formValues,
                                        DateTime: date,
                                    })
                                }
                                minDate={new Date()}
                                locale="en"
                                showTimeSelect
                                timeFormat="p"
                                timeIntervals={15}
                                dateFormat="Pp"
                                closeOnScroll={(e) => e.target === document}
                                customInput={<ExampleCustomInput />}
                                wrapperClassName={styles.datePicker}
                                onSelect={handleSelect}
                                required
                                onCalendarClose={() => setCalendarClose(true)}
                            />
                        </div>
                        {errors.DateTime && (
                            <span style={{ color: "red" }}>
                                {errors.DateTime}
                            </span>
                        )}
                        <br />
                    </div>
                )} */}

                {origin.types.includes("airport") && (
                    <div class="alert alert-danger" role="alert">
                        Flight details are mandatory
                    </div>
                )}

                <div className="row mb-5">
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Flight Number
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Flight Number"
                            name="FlightNumber"
                            onChange={handleFormChange}
                            value={formValues.FlightNumber}
                        />
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>Airline Name</label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Airline Name"
                            name="AirlineName"
                            onChange={handleFormChange}
                            value={formValues.AirlineName}
                        />
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>Arrival Time</label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Arrival Time"
                            name="ArrivalTime"
                            onChange={handleFormChange}
                            value={formValues.ArrivalTime}
                        />
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Departure Time
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Departure Time"
                            name="DepartureTime"
                            onChange={handleFormChange}
                            value={formValues.DepartureTime}
                        />
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Number of Passengers{" "}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Number of Passengers"
                            name="Passengers"
                            type="number"
                            onChange={handleFormChange}
                            value={formValues.Passengers}
                            onBlur={() => {
                                if (formValues.Passengers < 0) {
                                    setFormValues({
                                        ...formValues,
                                        Passengers: 1,
                                    });
                                }
                            }}
                        />
                        {errors.Passengers && (
                            <span style={{ color: "red" }}>
                                {errors.Passengers}
                            </span>
                        )}
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Number of Hand-Carry
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Number of Hand-carry"
                            name="HandCarry"
                            type="number"
                            onChange={handleFormChange}
                            value={formValues.HandCarry}
                            onBlur={() => {
                                if (formValues.HandCarry < 0) {
                                    setFormValues({
                                        ...formValues,
                                        HandCarry: 0,
                                    });
                                }
                            }}
                        />
                        {errors.HandCarry && (
                            <span style={{ color: "red" }}>
                                {errors.HandCarry}
                            </span>
                        )}
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Number of Large Suitcases
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Number of Large Suitcases"
                            name="Suitcases"
                            type="number"
                            onChange={handleFormChange}
                            value={formValues.Suitcases}
                            onBlur={() => {
                                if (formValues.Suitcases < 0) {
                                    setFormValues({
                                        ...formValues,
                                        Suitcases: 0,
                                    });
                                }
                            }}
                        />
                        {errors.Suitcases && (
                            <span style={{ color: "red" }}>
                                {errors.Suitcases}
                            </span>
                        )}
                    </div>
                    <div>
                        {/* dropdown */}
                        <div>
                            <label className={styles.formLabel}>Select</label>
                            <Select
                                defaultValue={selectedOption}
                                className={`${styles.Dropdown}`}
                                formInput
                                onChange={setSelectedOption}
                                options={options}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: "black",
                                        borderRadius: "5px",
                                        "&:hover": {
                                            borderColor: "none",
                                            boxShadow: "none",
                                        },
                                    }),
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#b68b47",
                                        primary: "black",
                                    },
                                })}
                            />
                        </div>
                        {/* dropdown */}
                        <div className="row">
                            <div className="col-lg-6">
                                {selectedOption.value === "NameBoard" && (
                                    <div className="col-lg">
                                        <label className={styles.formLabel}>
                                            Enter the name to display on
                                            nameboard
                                        </label>
                                        <input
                                            className={styles.formInput}
                                            placeholder="Enter Nameboard"
                                            name="NameBoard"
                                            onChange={handleFormChange}
                                            value={formValues.NameBoard}
                                        />
                                    </div>
                                )}
                                <div className={styles.CompanylogoSelected}>
                                    {selectedOption.value === "CompanyLogo" && (
                                        <div
                                            className="col-lg"
                                            style={{ marginTop: "29px" }}
                                        >
                                            <div
                                                class="alert alert-dark"
                                                role="alert"
                                            >
                                                <p class="alert-heading">
                                                    Please note company logo
                                                    will be displayed on the
                                                    nameboard
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <label className={styles.formLabel}>
                                    Send Driver Inside
                                </label>
                                <Select
                                    defaultValue={optionsSecond[0]}
                                    className={`${styles.Dropdown}`}
                                    formInput
                                    onChange={(e) => {
                                        setFormValues({
                                            ...formValues,
                                            sendDriverInside: e.value,
                                        });
                                    }}
                                    options={optionsSecond}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: "black",
                                            borderRadius: "5px",
                                            padding: "2px 8px",
                                            "&:hover": {
                                                borderColor: "none",
                                                boxShadow: "none",
                                            },
                                        }),
                                    }}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 0,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#b68b47",
                                            primary: "black",
                                        },
                                    })}
                                />
                            </div>
                            <div className="col-lg mt-4">
                                {selectedOptionSecond.value ===
                                "Immediately" ? (
                                    <div
                                        class="alert alert-success"
                                        role="alert"
                                    >
                                        <p class="alert-heading">
                                            Note: We'll send the driver inside
                                            immediately after the flight lands
                                        </p>
                                    </div>
                                ) : selectedOptionSecond.value ===
                                  "15minutes" ? (
                                    <div
                                        class="alert alert-success"
                                        role="alert"
                                    >
                                        <p class="alert-heading">
                                            Note: We'll send the driver inside
                                            15 minutes after the flight lands
                                        </p>
                                    </div>
                                ) : selectedOptionSecond.value ===
                                  "30minutes" ? (
                                    <div
                                        class="alert alert-success"
                                        role="alert"
                                    >
                                        <p class="alert-heading">
                                            Note: We'll send the driver inside
                                            30 minutes after the flight lands
                                        </p>
                                    </div>
                                ) : selectedOptionSecond.value ===
                                  "45minutes" ? (
                                    <div
                                        class="alert alert-success"
                                        role="alert"
                                    >
                                        <p class="alert-heading">
                                            Note: We'll send the driver inside
                                            45 minutes after the flight lands
                                        </p>
                                    </div>
                                ) : selectedOptionSecond.value === "1hour" ? (
                                    <div
                                        class="alert alert-success"
                                        role="alert"
                                    >
                                        <p class="alert-heading">
                                            Note: We'll send the driver inside 1
                                            hour after the flight lands
                                        </p>
                                    </div>
                                ) : (
                                    <p></p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <label className={styles.formLabel}>Additional Comments</label>
                <textarea
                    className={styles.formInput}
                    placeholder="Add any additional comments"
                    rows={5}
                    name="AdditionalComments"
                    onChange={handleFormChange}
                    value={formValues.AdditionalComments}
                />
            </div>
            <div className="row gy-3 pb-5">
                <div className="col-sm-12 col-md-6 text-center order-md-0 order-1">
                    <button
                        className={`${styles.previousBtn}`}
                        onClick={() => setStep(3)}
                    >
                        Go to Previous Page
                    </button>
                </div>
                <div className="col-sm-12 col-md-6 text-center order-md-1 order-0">
                    <button
                        className={`${styles.nextBtn}`}
                        onClick={() => (validateForm() ? setStep(5) : "")}
                    >
                        Go to Payment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StepFour;
